<!--
 * @Description: 考级历史记录
 * @Author: chenguobiao
 * @Date: 2021-07-13 11:27:29
 * @LastEditTime: 2021-08-14 16:02:19
 * @LastEditors: chenguobiao
-->
<template>
  <div class="grading-history flex flex-col">
    <div class="grading-history__title flex items-center justify-between">
      <span>考级历史</span>
    </div>
    <div class="grading-history__list">
      <template v-if="list && list.length > 0">
        <grading-item v-for="item in list" :key="item.uid" :info="item" @click.native="handleClick(item.uid)"></grading-item>
      </template>
      <template v-else>
        <div class="grading-history__list__nodata">
          <img src="@/render/assets/images/home/nodata.png">
          <div class="grading-history__list__nodata__text">暂无考级数据</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import GradingItem from './GradingItem.vue'
export default {
  props: ['list'],
  data() {
    return {
    }
  },
  components: {
    GradingItem
  },
  methods: {
    handleClick(testLogUid) {
      this.$emit('clickGrading', testLogUid)
    }
  },
}
</script>

<style lang="scss" scoped>
  .grading-history {
    flex: 1;
    width: val(1200);
    margin: 0 auto;
    box-sizing: border-box;
    &__title {
      height: val(60);
      border-bottom: 1px solid rgba(#2D2800, 0.3);
      span {
        font-size: val(20);
        color: var(--fonts-normal-color);
      }
    }
    &__list {
      position: relative;
      flex: 1;
      display: flex;
      flex-wrap: wrap;
      padding: val(14) 0 val(6);
      ::v-deep {
        .grading-item {
          cursor: pointer;
          margin-right: val(30);
          margin-bottom: val(30);
          &:nth-of-type(3n) {
            margin-right: 0;
          }
          &:nth-last-of-type(-n + 3) {
            margin-bottom: 0;
          }
        }
      }
      &__nodata{
        position: absolute;
        width: val(286);
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        &__text {
          margin: val(30) auto 0;
          text-align: center;
          font-size: val(20);
          font-weight: 400;
          color: #727272;
        }
      }
    }
  }
</style>
